if (!customElements.get('sale-video-popup')) {
  class SaleVideoPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.sale-popup__dialog');
      this.overlay = this.querySelector('.sale-popup__overlay');
      this.video = this.querySelector('video');
      this.sectionId = this.dataset.sectionId;
      this.storeKey = 'naturall-sale-popup';
      this.sessionKey = 'naturall-popup-shown';
      this.delayMs = parseInt(this.dataset.delay || '0', 10) * 1000;
      this.dismissDays = parseInt(this.dataset.dismissDays || '30', 10);
      this.designMode = this.dataset.designMode !== undefined;
      this.isOpen = false;
      this.onKeydown = this.onKeydown.bind(this);

      this.querySelectorAll('[data-sale-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.querySelector('[data-sale-cta]')?.addEventListener('click', () => this.remember());

      if (this.designMode) {
        document.addEventListener('shopify:section:select', (e) => { if (e.detail.sectionId === this.sectionId) this.open(); });
        document.addEventListener('shopify:section:deselect', (e) => { if (e.detail.sectionId === this.sectionId) this.close(); });
      }

      if (new URLSearchParams(window.location.search).get('sale-popup') === 'preview') {
        this.open();
        return;
      }
      if (this.designMode) return;
      if (this.dataset.signedIn !== undefined) return;
      const endsAt = parseInt(this.dataset.endsAt || '0', 10);
      if (endsAt && Date.now() > endsAt * 1000) return;

      const state = this.getState();
      if (state.seenAt && Date.now() - state.seenAt < this.dismissDays * 86400000) return;
      // Someone who already met the brush popup is a returning visitor.
      try { if (localStorage.getItem('naturall-brush-popup')) return; } catch (e) {}

      window.setTimeout(() => {
        if (document.documentElement.dataset.guideSignupActive === '1') return;
        let otherShown = false;
        try { otherShown = sessionStorage.getItem(this.sessionKey) === '1'; } catch (e) {}
        if (otherShown || document.querySelector('.brush-popup__dialog:not([hidden])')) return;
        this.open();
      }, this.delayMs);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      try { sessionStorage.setItem(this.sessionKey, '1'); } catch (e) {}
      if (!this.designMode) this.remember();
      this.lastFocus = document.activeElement;
      this.overlay.hidden = false;
      this.dialog.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      if (this.video && this.video.dataset.poster && !this.video.poster) this.video.poster = this.video.dataset.poster;
      if (this.video && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.play().catch(() => {});
      } else if (this.video) {
        this.video.controls = true;
      }
      (this.querySelector('[data-sale-cta]') || this.dialog).focus();
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.overlay.hidden = true;
      this.dialog.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      if (this.video) this.video.pause();
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    remember() {
      try { localStorage.setItem(this.storeKey, JSON.stringify({ seenAt: Date.now() })); } catch (e) {}
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(this.dialog.querySelectorAll('button, [href]')).filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    getState() {
      try { return JSON.parse(localStorage.getItem(this.storeKey)) || {}; } catch (e) { return {}; }
    }
  }

  customElements.define('sale-video-popup', SaleVideoPopup);
}
